export default [
    {
        id:1,
        username:"abc312",
        name:"john",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:34,     
        date:"25-2-22", 
        link:"urqiegiuhi./fekjh.ekj"  
    },
    {
        id:2,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"urqiegiuhi./fekjh.ekj"
    },   
    {
        id:3,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"urqiegiuhi./fekjh.ekj"
    }, 
    {
        id:4,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:5,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:6,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,        
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:7,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:8,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:9,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    }, 
    {
        id:10,
        username:"abc31142",
        name:"mark",
        desc:"uygfwgifue ygr grsth jgiorelkhmgkr;k hgsarios",
        points:22,
        date:"20-2-22",   
        link:"Solve Problem >"
    },     
]